<div class="create-query-container create-query-container" nzCompact>
    <form [formGroup]="updateQueryForm" (ngSubmit)="onSubmit()" class="ant-advanced-search-form">
        <div class="form-row bg-dark-blue text-white">
            <span class="span-header">Query Details</span>
        </div>
        <br />
        <div class="row form-group">
            <div class="col-md-2">
                <label>Reference Number</label>
            </div>
            <div class="col-md-3">
                <input nz-input value="{{queryModel.Query_Reference_Number}}" style="font-weight: bold;"
                    name="QueryReferenceNumber" type="text" class="form-control" disabled />
            </div>
            <div class="col-md-3 col-md-push-1">
                <label>Date of Request</label>
            </div>
            <div class="col-md-3">
                <input nz-input value="{{queryModel.Created_Date | date:'dd-MMM-yyyy'}}" name="CreatedDate" type="text"
                    class="form-control" disabled />
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-2">
                <label>Subject</label>
            </div>
            <div class="col-md-3">
                <input nz-input name="Subject" type="text" class="form-control" disabled value="{{queryModel.Subject}}"
                    title="{{queryModel.Subject}}" />
            </div>
            <div class="col-md-3 col-md-push-1">
                <label>Request Status</label>
            </div>
            <div class="col-md-3">
                <input nz-input title="{{queryModel.QueryStatus}}" value="{{queryModel.QueryStatus}}"
                    style="font-weight: bold;" name="QueryStatus" type="text" class="form-control" disabled />
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-2">
                <label>Priority</label>
            </div>
            <div class="col-md-3">
                <input nz-input value="{{queryModel.QueryDetail.PriorityLevel}}"
                    title="{{queryModel.QueryDetail.PriorityLevel}}" name="PriorityLevel" type="text"
                    class="form-control" disabled />
            </div>
            <div class="col-md-3 col-md-push-1">
                <label>Confidential</label>
            </div>
            <div class="col-md-3">
                <input type="checkbox" name="Partner_Confidential" class="chckbx-Confidential"
                    [checked]="queryDetail.Is_Confidential" onclick="return false;" />
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-2">
                <label>CC Emails</label>
            </div>
            <div class="col-md-3">
                <textarea nz-input type="text" rows="3" class="form-control" name="CCEmails"
                    value="{{queryDetail.CCEmails}}" disabled></textarea>
            </div>
           
                <div class="col-md-3 col-md-push-1" *ngIf="queryModel.CanViewPrevsQueryDtls">
                    <label>Query Type</label>
                </div>
                <div class="col-md-3" *ngIf="queryModel.CanViewPrevsQueryDtls">
                    <input nz-input value="Re-Opened" name="Query Type" type="text" style="font-weight: bold;"
                        class="form-control" disabled />
                </div>
            
        </div>


        <div>
            <div class="form-row bg-dark-blue text-white">
                <span class="span-header">Requestor Details</span>
            </div>
            <br />
            <div class="row form-group">
                <div class="col-md-2">
                    <label>Requestor Name</label>
                </div>
                <div class="col-md-3">
                    <input nz-input value="{{queryModel.RequestorDetail.User_Name}}" name="RequestorDetail.User_Name"
                        type="text" class="form-control" disabled />
                </div>
                <div class="col-md-3 col-md-push-1">
                    <label>Requestor Email</label>
                </div>
                <div class="col-md-3">
                    <input nz-input value="{{queryModel.RequestorDetail.Email}}" name="RequestorDetail.Email"
                        type="text" class="form-control" disabled />
                </div>
            </div>
            <div class="row form-group">
                <div class="col-md-2">
                    <label>Company:</label>
                </div>
                <div class="col-md-3">
                    <input nz-input value="{{queryDetail.CompanyName}}" name="CompanyName" type="text"
                        class="form-control" disabled />
                </div>
                <div class="col-md-3 col-md-push-1">
                    <label>Block</label>
                </div>
                <div class="col-md-3">
                    <input nz-input value="{{queryDetail.Block}}" name="BlockName" type="text" class="form-control"
                        disabled />
                </div>
            </div>
        </div>
        <!-- Clarification Request Details Section -->
        <div>
            <div class="form-row bg-dark-blue text-white">
                <span class="span-header">Clarification Request Details</span>
            </div>
            <br />
            <div class="row form-group">
                <div class="col-md-2">
                    <!-- <label>Block</label> -->
                </div>
                <div class="col-md-3">
                    <!-- <input value="{{queryDetail.Block}}" name="BlockName" type="text" class="form-control" disabled /> -->
                </div>
                <div class="col-md-3 col-md-push-1">
                </div>
                <div class="col-md-3" *ngIf="queryModel.CanViewPrevsQueryDtls">
                    <button nz-button nzType="primary"
                        routerLink="/clarification-query/view-previous-query-details/{{queryCode}}">
                        Previous Query Resolutions Details
                    </button>
                </div>
            </div>

            <div class="row form-group">
                <div class="col-md-2 required">
                    <label>Department<span class="text-danger">*</span></label>
                </div>
                <div class="col-md-3">
                    <nz-select id="department" 
                        class="form-control" formControlName="department" (ngModelChange)="onDepartmentChange($event)"
                        nzPlaceHolder="Choose" nzAllowClear [nzStatus]="getNzStatusColor('department')">
                        <nz-option *ngFor="let department of departmentMaster" [nzValue]="department.Department_Code"
                            [nzLabel]="department.Department_Name"></nz-option>
                    </nz-select>
                    <div
                        *ngIf="updateQueryForm.get('department')?.touched && updateQueryForm.get('department')?.invalid">
                        <small class="text-danger" *ngIf="updateQueryForm.get('department')?.errors?.['required']">
                            Department is required.
                        </small>
                    </div>
                </div>
                <div class="col-md-3 col-md-push-1 required">
                    <label>Sub Department<span class="text-danger">*</span></label>
                </div>
                <div class="col-md-3">
                    <nz-select id="subDepartment" formControlName="subDepartment" nzPlaceHolder="Choose" nzAllowClear
                        style="width: 100%;" [nzStatus]="getNzStatusColor('subDepartment')">

                        <nz-option *ngFor="let subDepartment of deptSubDeptMaster | orderby: 'Sub_Dept_Name'"
                            [nzValue]="subDepartment.Sub_Dept_Code" [nzLabel]="subDepartment.Sub_Dept_Name"
                            nzMode="single"></nz-option>
                    </nz-select>
                    <div
                        *ngIf="updateQueryForm.get('subDepartment')?.touched && updateQueryForm.get('subDepartment')?.invalid">
                        <small class="text-danger" *ngIf="updateQueryForm.get('subDepartment')?.errors?.['required']">
                            Sub Department is required.
                        </small>
                    </div>
                </div>
            </div>


            <div class="row form-group">
                <div class="col-md-2">
                    <label>CC Sub Departments</label>
                </div>
                <div class="col-md-9">
                    <nz-select id="ccSubDepartment" formControlName="ccSubDepartment" nzMode="multiple"
                        nzPlaceHolder="Select CC Sub Departments" 
                        style="width: 100%;">
                        <nz-option *ngFor="let item of CCSubDepartmentsMaster" [nzLabel]="item.Value"
                            [nzValue]="item.Id"></nz-option>
                    </nz-select>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-md-2">
                    <label>CC</label>
                </div>
                <div class="col-md-9">
                    <nz-select id="cc" formControlName="cc" nzMode="multiple" nzPlaceHolder="Select CC"
                         style="width: 100%;">
                        <nz-option *ngFor="let item of partnerUserMaster" [nzLabel]="item.User_Name"
                            [nzValue]="item.User_Code"></nz-option>
                    </nz-select>
                </div>
            </div>


            <div class="row form-group">
                <div class="col-md-2 required">
                    <label>Partner Comments<span class="text-danger">*</span></label>
                </div>
                <div class="col-md-6">
                    <textarea rows="3" nz-input value="{{queryDetail.Partner_Comment}}" name="Partner_Comment"
                        type="text" disabled class="form-control"></textarea>
                </div>
                <div class="col-md-3">
                    <button type="button" nz-button nzType="primary" (click)="viewAttachments(true)">
                        View Attachments
                    </button>
                    <div>
                        <label> Attachment count - {{ partnerUploadedAttachmtCnt }}</label>
                    </div>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-md-2">
                    <label>Company Restricted</label>
                </div>
                <div class="col-md-6">
                    <label nz-checkbox [formControlName]="'Company_Restricted'" >                        
                      </label> 
                </div>
            </div>
            <div class="row form-group">
                <div class="col-md-2 required">
                    <label>Query Category<span class="text-danger">*</span></label>
                </div>
                <div class="col-md-3">
                    <nz-select id="Clarification_Cat_Code" 
                        class="form-control" formControlName="Clarification_Cat_Code" (ngModelChange)="onCategorySelect($event)"
                        nzPlaceHolder="Choose" nzAllowClear [nzStatus]="getNzStatusColor('Clarification_Cat_Code')">
                        <nz-option *ngFor="let c of categoryMaster" [nzValue]="c.Cat_Code"
                            [nzLabel]="c.Desc"></nz-option>
                    </nz-select>
                    <div
                        *ngIf="updateQueryForm.get('Clarification_Cat_Code')?.touched && updateQueryForm.get('Clarification_Cat_Code')?.invalid">
                        <small class="text-danger" *ngIf="updateQueryForm.get('Clarification_Cat_Code')?.errors?.['required']">
                            Query Category is required.
                        </small>
                    </div>
                </div>
                <div class="col-md-3 col-md-push-1 required" *ngIf="(queryDetail.Clarification_Cat_Code == '1' || queryDetail.Clarification_Cat_Code == '2')">
                    <label>Query Sub Category<span class="text-danger">*</span></label>
                </div>
                <div class="col-md-3" *ngIf="(queryDetail.Clarification_Cat_Code == '1' || queryDetail.Clarification_Cat_Code == '2')">
                    <nz-select id="Clarification_SubCat_Code" 
                        class="form-control" formControlName="Clarification_SubCat_Code" (ngModelChange)="onSubCategorySelect($event)"
                        nzPlaceHolder="Choose" nzAllowClear [nzStatus]="getNzStatusColor('Clarification_SubCat_Code')">
                        <nz-option *ngFor="let item of catSubCatMaster | orderby : 'SubCatDesc' " [nzValue]="item.Sub_Cat_Code"
                            [nzLabel]="item.SubCatDesc"
                            ></nz-option>
                    </nz-select>
                    <div
                        *ngIf="updateQueryForm.get('Clarification_SubCat_Code')?.touched && updateQueryForm.get('Clarification_SubCat_Code')?.invalid">
                        <small class="text-danger" *ngIf="updateQueryForm.get('Clarification_SubCat_Code')?.errors?.['required']">
                            Query Sub Category is required.
                        </small>
                    </div>
                </div>
            </div>
            <div class="row form-group" *ngIf="((queryDetail.Clarification_Cat_Code == '1' || queryDetail.Clarification_Cat_Code == '2')
              && (queryDetail.Clarification_SubCat_Code != '') && !isCategoryCommentVisible)">
                <div class="col-md-2">
                    <label>Letter Reference Number</label>
                </div>
                <div class="col-md-3">
                    <input nz-input formControlName="letterReferenceNumber" name="LetterReferenceNumber" type="text"
                        class="form-control" maxlength="25" />
                </div>

                <div class="col-md-3 col-md-push-1" *ngIf="isContractNumberVisible">
                    <label>Contract Number</label>
                </div>
                <div class="col-md-3" *ngIf="isContractNumberVisible">
                    <input nz-input formControlName="contractNumber" name="contractNumber" type="text"
                        class="form-control" maxlength="25" />
                </div>


                <div class="col-md-3 col-md-push-1" *ngIf="isAFEVisible">
                    <label>AFE Number</label>
                </div>
                <div class="col-md-3" *ngIf="isAFEVisible">
                    <input nz-input name="AFENumber" type="text" formControlName="afeNumber" class="form-control"
                        maxlength="25" />
                </div>


                <div class="col-md-3 col-md-push-1 " *ngIf="isWOVisible">
                    <label>Work Order Number</label>
                </div>
                <div class="col-md-3" *ngIf="isWOVisible">
                    <input nz-input name="WorkOrderNumber" formControlName="workOrderNumber" type="text" class="form-control"
                        maxlength="25" />
                </div>

            </div>
            <div class="row form-group"
                *ngIf="(queryDetail.Clarification_Cat_Code != '' && queryDetail.Clarification_Cat_Code != '1' && queryDetail.Clarification_Cat_Code != '2') || (isCategoryCommentVisible)">
                <div class="col-md-2 required">
                    <label>Category Comments</label>
                </div>
                <div class="col-md-6">
                    <textarea nz-input rows="3" formControlName="categoryComment" name="CategoryComment" type="text"
                        class="form-control"
                        [ngClass]="{'is-invalid': updateQueryForm.get('categoryComment')?.touched && updateQueryForm.get('categoryComment')?.invalid}"></textarea>
                    <div
                        *ngIf="updateQueryForm.get('categoryComment')?.touched && updateQueryForm.get('categoryComment')?.invalid">
                        <small class="text-danger" *ngIf="updateQueryForm.get('categoryComment')?.errors?.['required']">
                            Category comments is required.
                        </small>
                    </div>
                </div>
            </div>
        </div>
        <!-- Section Query Resolution Details -->
        <div>
            <div class="form-row bg-dark-blue text-white">
                <span class="span-header">Clarification Request Details</span>
            </div>
            <br />

            <div *ngIf="queryModel.QueryStatusEnum !=queryNewEnum && queryModel.QueryStatusEnum !=queryReOpenedEnum">
                <div class="row form-group">
                    <div class="col-md-2">
                        <label>Consolidated Comments</label>
                    </div>
                    <div class="col-md-6">
                        <div>
                            <p id="consolidatedComment" class="consolidate-comments" readonly="readonly"
                                style="font-size: 90%;" [innerHTML]="queryDetail.ConsolidatedCommentInString" disabled>
                            </p>
                        </div>
                        <div>
                            <a (click)="viewComments()" style="cursor: pointer;text-decoration: underline;">View
                                Comments</a>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <button nz-button nzType="primary" (click)="viewAttachments(false)">
                            View Attachments
                        </button>
                        <div>
                            <label> Attachment count - {{internalUserUploadedAttachmtCnt}}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row form-group">
                <div class="col-md-2 required">
                    <label>Comment<span class="text-danger">*</span> </label>
                </div>
                <div class="col-md-6">
                    <textarea nz-input rows="3" formControlName="additionalComments" name="Comment" type="text"
                        class="form-control" 
                        [ngClass]="{'is-invalid': updateQueryForm.get('additionalComments')?.touched && updateQueryForm.get('additionalComments')?.invalid}">
                    </textarea>
                    <div
                        *ngIf="updateQueryForm.get('additionalComments')?.touched && updateQueryForm.get('additionalComments')?.invalid">
                        <small class="text-danger" *ngIf="updateQueryForm.get('additionalComments')?.errors?.['required']">
                            Comment is required.
                        </small>
                    </div>
                </div>
                <div class="col-md-3">
                    <button nz-button nzType="primary" (click)="openFileUploadModal()">
                        Add Attachments
                    </button>
                    <div>
                        <label>Attachment count - {{files.length}}</label>
                    </div>
                </div>
            </div>

        </div>
        <div class="row form-group button-container" *ngIf="((queryModel.QueryStatusEnum == queryNewEnum
                                                || queryModel.QueryStatusEnum == queryReOpenedEnum)
                                                && queryPermission.canUpdateQuery)"
            style="display: flex; justify-content: flex-end; align-items: center; ">
            <div class="col-md-6 col-md-push-2">
                <button *ngIf="queryPermission.canNotifyToPartner" (click)="openNotifyToPartnerModal()" nz-button
                    nzType="primary">
                    Notify Partner
                </button>
                &nbsp;
                <button *ngIf="queryPermission.canAssignToDept" (click)="openNotifyToDepartmentModal()" nz-button
                    nzType="primary" style="margin-left: 10px;">
                    Notify Dept. Rep
                </button>
                &nbsp;
                <button (click)="redirectToQueryRequest()" nz-button nzType="primary" style="margin-left: 10px;">
                    Back
                </button>
            </div>
        </div>

        <div class="row form-group button-container" *ngIf="((queryModel.QueryStatusEnum == queryAssignedToDeptEnum
                                    || queryModel.QueryStatusEnum == queryRecycledEnum)
                                    && queryPermission.canUpdateQuery)"
            style="display: flex; justify-content: flex-end; align-items: center; ">
            <div class="col-md-6 col-md-push-2">

                <button *ngIf="queryPermission.canProvideAddtionlComments" (click)="addAdditionalCommentModal()" nz-button
                    nzType="primary">
                    Add Additional Comment
                </button>
                <button *ngIf="queryPermission.canProvideQueryAnsToRFCAdmin" (click)="notifyToRFCAdminModal()"
                    style="margin-left: 10px;" nz-button nzType="primary">Notify RFC Admin</button>

                <button (click)="redirectToQueryRequest()" nz-button nzType="primary"
                    style="margin-left: 10px;">Back</button>

            </div>
        </div>
        
        <div class="row form-group" *ngIf="((queryModel.QueryStatusEnum == queryAnsweredByDeptEnum
                                        || queryModel.QueryStatusEnum == queryAnsweredBySponsorEnum)
                            && queryPermission.canUpdateQuery)" style="display: flex; justify-content: flex-end; align-items: center; ">
            <div class="col-md-6 col-md-push-2">
                <button nz-button nzType="primary" *ngIf="queryPermission.canProvideAddtionlComments" (click)="addAdditionalCommentModal()">
                    Add Additional Comment
                </button>
                &nbsp;
                <button nz-button nzType="primary" *ngIf="queryPermission.canNotifyToPartner" (click)="notifyResponseToPartnerModal()" style="margin-left: 10px;">
                    Notify Partner
                </button>
                &nbsp;
                <button nz-button nzType="primary" (click)="redirectToQueryRequest()" style="margin-left: 10px;">Back</button>
            </div>
        </div>





    </form>
</div>